(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mountainDropCatalogTabsBootstrapped) return;
    window.__mountainDropCatalogTabsBootstrapped = true;

    const initRoot = (root) => {
      if (!root || root.dataset.mdTabsInitialized === 'true') return;
      root.dataset.mdTabsInitialized = 'true';

      const buttons = Array.from(root.querySelectorAll('[data-md-tab]'));
      const select = root.querySelector('[data-md-tab-select]');
      const tablist = root.querySelector('[role="tablist"]');

      const connectedGrid = () => Array.from(document.querySelectorAll('[data-md-product-grid]'))
        .find((grid) => grid.dataset.mdConnection === root.dataset.mdConnection);

      const initialGrid = connectedGrid();
      if (initialGrid) {
        initialGrid.setAttribute('role', 'tabpanel');
        buttons.forEach((button) => button.setAttribute('aria-controls', initialGrid.id));
        const activeButton = buttons.find((button) => button.getAttribute('aria-selected') === 'true');
        if (activeButton) initialGrid.setAttribute('aria-labelledby', activeButton.id);
      }

      const setActive = (value) => {
        buttons.forEach((button) => {
          const active = button.dataset.value === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });
        const grid = connectedGrid();
        const activeButton = buttons.find((button) => button.dataset.value === value);
        if (grid && activeButton) grid.setAttribute('aria-labelledby', activeButton.id);
        if (select && select.value !== value) select.value = value;
      };

      const replaceGrid = async (url, value, templateId = '') => {
        const grid = connectedGrid();
        if (!grid || (!url && !templateId) || root.classList.contains('is-loading')) return;

        root.classList.add('is-loading');
        grid.setAttribute('aria-busy', 'true');

        try {
          if (templateId) {
            const template = document.getElementById(templateId);
            if (!template) throw new Error('Selected product template was not found');

            let items = grid.querySelector('.md-product-grid__items');
            if (!items) {
              items = document.createElement('div');
              items.className = 'md-product-grid__items';
              items.setAttribute('role', 'list');
              const status = grid.querySelector('[data-md-cart-status]');
              grid.insertBefore(items, status || null);
            }

            grid.querySelector('.md-product-grid__empty')?.remove();
            items.replaceChildren(template.content.cloneNode(true));
            grid.removeAttribute('aria-busy');
            setActive(value);
            document.dispatchEvent(new CustomEvent('md:collection:changed', {
              detail: {
                connection: root.dataset.mdConnection,
                source: 'products',
                productCount: items.querySelectorAll('[data-md-product-card]').length
              }
            }));
            return;
          }

          const separator = url.includes('?') ? '&' : '?';
          const renderSection = (sectionId) => fetch(
            `${url}${separator}section_id=${encodeURIComponent(sectionId)}`,
            { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
          );
          let response = await renderSection(grid.dataset.sectionId);
          if (!response.ok && grid.dataset.sectionId !== 'md-product-grid') {
            response = await renderSection('md-product-grid');
          }
          if (!response.ok) throw new Error(`Unable to load collection (${response.status})`);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = documentFragment.querySelector('[data-md-product-grid]');
          if (!nextGrid) throw new Error('Connected product grid was not returned');

          grid.replaceChildren(...Array.from(nextGrid.childNodes));
          grid.removeAttribute('aria-busy');
          setActive(value);
          document.dispatchEvent(new CustomEvent('md:collection:changed', {
            detail: { connection: root.dataset.mdConnection, url }
          }));
        } catch (error) {
          console.error('[Mountain Drop catalog]', error);
          grid.removeAttribute('aria-busy');
          if (url) window.location.assign(url);
        } finally {
          root.classList.remove('is-loading');
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => replaceGrid(
          button.dataset.url,
          button.dataset.value,
          button.dataset.templateId
        ));
      });

      tablist?.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        const currentIndex = Math.max(0, buttons.indexOf(document.activeElement));
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        buttons[nextIndex]?.focus();
      });

      if (select) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          replaceGrid(option.dataset.url, option.value, option.dataset.templateId);
        });
      }

      const activeButton = buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0];
      if (activeButton) {
        setActive(activeButton.dataset.value);
      }
      if (activeButton?.dataset.templateId) {
        replaceGrid(activeButton.dataset.url, activeButton.dataset.value, activeButton.dataset.templateId);
      }
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-md-catalog-tabs]')) initRoot(scope);
      scope.querySelectorAll?.('[data-md-catalog-tabs]').forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mountainDropProductGridBound) return;
    window.__mountainDropProductGridBound = true;

    const cardFor = (element) => element.closest('[data-md-product-card]');
    const findCartDrawer = () => document.querySelector('cart-drawer')
      || document.querySelector('#CartDrawer')
      || document.querySelector('[data-cart-drawer]');

    const openCartDrawer = (drawer) => {
      if (!drawer) return false;

      drawer.classList.remove('is-empty');

      if (typeof drawer.show === 'function') {
        drawer.show();
        return true;
      }

      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('active', 'is-open');
      return true;
    };

    document.addEventListener('click', (event) => {
      const variantButton = event.target.closest('[data-md-variant]');
      if (!variantButton) return;

      const card = cardFor(variantButton);
      if (!card) return;

      card.querySelectorAll('[data-md-variant]').forEach((button) => {
        const active = button === variantButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const variantInput = card.querySelector('[data-md-variant-input]');
      const price = card.querySelector('[data-md-price]');
      const comparePrice = card.querySelector('[data-md-compare-price]');
      const addButton = card.querySelector('.md-product-card__quick-add');
      const addLabel = card.querySelector('[data-md-add-label]');
      const available = variantButton.dataset.available === 'true';

      if (variantInput) variantInput.value = variantButton.dataset.variantId;
      if (price) price.textContent = variantButton.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = variantButton.dataset.comparePrice || '';
        comparePrice.hidden = !variantButton.dataset.comparePrice;
      }
      if (addButton) addButton.disabled = !available;
      if (addButton) {
        const productTitle = card.dataset.productTitle || 'product';
        addButton.setAttribute('aria-label', available ? `Quick add ${productTitle}` : `${productTitle} is sold out`);
      }
      if (addLabel) addLabel.textContent = available ? 'Quick Add' : 'Sold Out';
    });

    const addToCart = async (form) => {
      if (!form || form.dataset.mdSubmitting === 'true') return;

      const card = cardFor(form);
      const button = form.querySelector('.md-product-card__quick-add');
      const label = form.querySelector('[data-md-add-label]');
      const status = form.closest('[data-md-product-grid]')?.querySelector('[data-md-cart-status]');
      const originalLabel = label?.textContent || 'Quick Add';
      const cartDrawer = findCartDrawer();
      const formData = new FormData(form);
      const shopRoot = window.Shopify?.routes?.root || '/';
      const cartRoot = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const sectionsToBundle = [];
      const drawerSection = cartDrawer?.closest('.shopify-section');
      const drawerSectionId = drawerSection?.id?.replace('shopify-section-', '');

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      if (drawerSectionId) sectionsToBundle.push(drawerSectionId);

      formData.set('on_success', 'force_open_drawer');
      formData.set('sections', [...new Set(sectionsToBundle.filter(Boolean))].join(','));
      formData.set('sections_url', `${cartRoot}cart`);

      if (button?.disabled) return;

      form.dataset.mdSubmitting = 'true';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      if (label) label.textContent = 'Adding…';

      const restoreButton = (delay) => {
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
          delete form.dataset.mdSubmitting;
        }, delay);
      };

      try {
        const response = await fetch(form.dataset.cartUrl || `${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const responseJson = await response.json();
        if (!response.ok) throw new Error(responseJson.description || 'Unable to add this product');

        const cart = await (await fetch(`${cartRoot}cart.js`)).json();
        cart.sections = responseJson.sections || {};
        const addedItems = responseJson.items || [responseJson];

        if (label) label.textContent = 'Added';
        if (status) status.textContent = `${responseJson.product_title || card?.dataset.productTitle || 'Product'} added to cart`;

        form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: addedItems,
            cart,
            onSuccessDo: 'force_open_drawer'
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart
          }
        }));

        openCartDrawer(cartDrawer || findCartDrawer());
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));

        restoreButton(1200);
      } catch (error) {
        if (label) label.textContent = 'Try Again';
        if (status) status.textContent = error.message;
        console.error('[Mountain Drop quick add]', error);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        restoreButton(1800);
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.md-product-card__quick-add');
      if (!button) return;

      const form = button.closest('[data-md-quick-add-form]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-md-quick-add-form]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-proof-batch-certificates"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-proof-batch-selector')) {
    customElements.define('md-proof-batch-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onChange = (event) => {
          if (!event.target.matches('[data-batch-select]')) return;
          this.showBatch(event.target.value, true);
        };
        this.onBlockSelect = (event) => {
          const panel = event.target.closest('[data-batch]');
          if (panel && this.contains(panel)) this.showBatch(panel.dataset.batch, false);
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      showBatch(id, announce) {
        let active;
        this.querySelectorAll('[data-batch]').forEach((panel) => {
          panel.hidden = panel.dataset.batch !== id;
          if (!panel.hidden) active = panel;
        });
        if (!active) return;
        this.querySelector('[data-batch-select]').value = id;
        if (announce) this.querySelector('[data-batch-status]').textContent = active.querySelector('.md-proof-testing__lot').textContent;
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
